import { DailyDiaryDetails, RegistryInternalDetails } from "src/app/components";
import BaseCard from "src/app/components/commonComponents/BaseCard";
import { TimelineData } from "src/shared/types/src";

const RegistryCard = ({ timelineItem }: { timelineItem: TimelineData }) => {

    return (
        <BaseCard customBaseCardStyle="mg-t-15">
            <RegistryInternalDetails timelineItem={timelineItem} />

            {timelineItem?.details?.notesData ? 
                <DailyDiaryDetails details={{ ...timelineItem?.details, notes: { ...timelineItem?.details?.notesData } }} /> :
                null
            }
        </BaseCard>
    )
}

export default RegistryCard;